import { FieldTitle } from './RedStarTitle';
import { UseFormRegisterReturn } from 'react-hook-form';
import { TextField } from '@client/new/components/basic';
import { FieldDesc } from './common';

type Props = {
  register: (s: string) => UseFormRegisterReturn;
  index: number;
};
export function TextSection({ register: r, index }: Props) {
  const MAX_DESC_LENGTH = 1000;

  return (
    <div className="">
      <section>
        <div>
          <FieldTitle title={'Headline text'} />
          <div className="mb-[5px] max-w-[578px]">
            <TextField
              {...r(`title`)}
              multiline
              rows={3}
              className="w-full"
              inputProps={{
                placeholder: 'Headline text',
                maxLength: 180,
              }}
            />
          </div>
        </div>

        <div className="mt-8">
          <FieldTitle title={'Body Text'} optional />
          <FieldDesc>
            Body Text (new lines are preserved, max {MAX_DESC_LENGTH}{' '}
            characters)
          </FieldDesc>
          <div className="mb-[5px] max-w-[578px] w-full">
            <TextField
              {...r(`desc`)}
              multiline
              rows={5}
              className="w-full"
              inputProps={{
                style: { height: '200px' },
                maxLength: MAX_DESC_LENGTH,
              }}
            />
          </div>
        </div>
      </section>
    </div>
  );
}
